import { managesDevicesAcrossCompanies } from 'src/app/models/user.model';
import { Dialog } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { DeviceCreateModalComponent } from 'src/app/components/modals/device-create-modal/device-create-modal.component';
import { selectProfileData } from 'src/app/stores/profile/profile.selector';

@Component({
  selector: 'app-all-resources',
  templateUrl: './all-resources.component.html',
  styleUrl: './all-resources.component.scss',
  standalone: false,
})
export class AllResourcesComponent {
  private readonly dialog = inject(Dialog);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly profile = toSignal(this.store.select(selectProfileData));

  get canCreateDevice(): boolean {
    return managesDevicesAcrossCompanies(this.profile());
  }

  openCreateDeviceModal(): void {
    const dialogRef = this.dialog.open<string | false>(
      DeviceCreateModalComponent,
      { autoFocus: 'dialog' },
    );

    dialogRef.closed.pipe(take(1)).subscribe((deviceId) => {
      if (typeof deviceId === 'string' && deviceId.trim()) {
        this.router.navigate(['/device', deviceId.trim()], {
          queryParams: { returnTo: '/admin/all-resources' },
        });
      }
    });
  }
}
